import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateTableHeader = () => {
  return (
    <tr
      id="report-column-header"
      className={`row-start-start ${tableWidth} text-sm bg-zinc-100 font-semibold text-slate-800 `}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border  px-2 h-full pb-2 pt-3 `}
      >
        {settings["no"].name}
      </td>

      <td
        className={`${settings["tanggal_transaksi"].layout} ${settings["tanggal_transaksi"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["tanggal_transaksi"].name}
      </td>

      <td
        className={`${settings["jenis_minyak"].layout} ${settings["jenis_minyak"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["jenis_minyak"].name}
      </td>

      <td
        className={`${settings["jumlah"].layout} ${settings["jumlah"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["jumlah"].name}
      </td>

      <td
        className={`${settings["harga_per_liter"].layout} ${settings["harga_per_liter"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["harga_per_liter"].name}
      </td>

      <td
        className={`${settings["total_harga"].layout} ${settings["total_harga"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["total_harga"].name}
      </td>

      <td
        className={`${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["speedo_akhir"].name}
      </td>
    </tr>
  );
};

export default ReportTemplateTableHeader;
